/**
 * Runtime config is injected by docker-entrypoint.sh into /env-config.js (window.__ENV__)
 * when the container starts. Falls back to VITE_* from .env for local development.
 */
const runtimeEnv: Record<string, string | undefined> = (typeof window !== "undefined" && window.__ENV__) || {};

function trimEnv(value: unknown): string | null {
  return typeof value === "string" && value.trim() !== "" ? value.trim() : null;
}

const get = (key: string): string => trimEnv(runtimeEnv[key]) ?? trimEnv(import.meta.env[`VITE_${key}`]) ?? "";

function resolveStudentPortalSignupUrl(): string | null {
  const explicit = trimEnv(get("STUDENT_PORTAL_SIGNUP_URL"));
  if (explicit) {
    return explicit;
  }
  const dev = trimEnv(import.meta.env.VITE_STUDENT_PORTAL_SIGNUP_URL_DEV);
  const prod = trimEnv(import.meta.env.VITE_STUDENT_PORTAL_SIGNUP_URL_PROD);
  return import.meta.env.PROD ? prod ?? dev : dev ?? prod;
}

/** Same text as the former runtime error; shown in the public catalog UI when the env var is unset. */
export const STUDENT_PORTAL_SIGNUP_MISSING_MESSAGE =
  "Missing student portal signup URL: set APP_STUDENT_PORTAL_SIGNUP_URL in the deployment config (or VITE_STUDENT_PORTAL_SIGNUP_URL in .env for local development).";

/** Student Portal sign-up URL for the current environment, or `null` if unset. */
export const STUDENT_PORTAL_SIGNUP_URL: string | null = resolveStudentPortalSignupUrl();

export const ENV = {
  HOST: get("SERVER_HOST"),
  PORT: get("SERVER_PORT"),
  /** Deployed release, e.g. "v1.0.0" (staging/prod) or "sha-f4e544d" (dev) */
  VERSION: get("VERSION"),
  GOOGLE_MAPS_API_KEY: get("GOOGLE_MAPS_API_KEY"),
  SENTRY_DSN: get("SENTRY_DSN"),
  SENTRY_ENVIRONMENT: get("SENTRY_ENVIRONMENT") || import.meta.env.MODE || "development",
  STUDENT_PORTAL_SIGNUP_URL,
};

// Compose the full URL
export const SERVER_URL = `${ENV.HOST}${ENV.PORT ? `:${ENV.PORT}` : ""}`;
